export const StackOverFlowSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <g clip-path="url(#clip0_1124_15002)">
        <path
          d="M19.022 3.78917L18.5254 3.11989L17.8562 3.6165L16.3223 4.75469L15.6531 5.25124L16.1496 5.92044L18.9782 9.73283L15.3475 6.71343L14.7064 6.18032L14.1737 6.82163L12.9611 8.28112L12.4289 8.92174L13.0692 9.45433L17.0408 12.7576L12.3472 10.5585L11.5813 10.1997L11.2339 10.9708L10.4423 12.7276L10.1043 13.478L10.8503 13.8254L15.0146 15.7647L10.5312 14.8278L9.71663 14.6576L9.54525 15.4719L9.14949 17.3523L8.97762 18.1688L9.79445 18.3396L13.626 19.1405H9.76667H8.93331L8.93334 19.9739L8.93341 21.879L8.93344 22.7123H9.76674H19.3178H20.1511V21.879V19.9738V19.5664L20.4148 18.3136V22.976H8.69494V18.0683V17.235H7.86161H5.9558H5.12247V18.0683V25.7143V26.5476H5.9558H23.1532H23.9866V25.7143V18.0682V17.2349H23.1532H21.2482H20.7186L21.4122 15.7173L21.4556 15.6225L21.592 15.4583L22.8047 13.9983L22.9878 13.7779L23.0066 13.7639L24.5406 12.6257L25.2098 12.1292L24.7133 11.4599L19.022 3.78917ZM0.833333 3.21429C0.833333 1.89997 1.89997 0.833333 3.21429 0.833333H26.7857C28.1 0.833333 29.1667 1.89997 29.1667 3.21429V26.7857C29.1667 28.1 28.1 29.1667 26.7857 29.1667H3.21429C1.89997 29.1667 0.833333 28.1 0.833333 26.7857V3.21429Z"
          fill="#F7790B"
          stroke="#F7790B"
          stroke-width="1.66667"
        />
      </g>
      <defs>
        <clipPath id="clip0_1124_15002">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
